module.exports = "data:image/gif;base64,R0lGODlhMgAhAMQAAAAAAP///2lpaXt7ewkJCTAwMOHh4VpaWgYGBvPz8zMzMxgYGBISEiEhIZycnMnJyfDw8MDAwPb29khISJmZmdXV1XJych4eHgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH5BAAAAAAALAAAAAAyACEAAAVgICCOZGmeaKqubOu+cCzPdG3feK7vfO//OcUFCBNIBgRiSxAIGA7KFbMZeBSiqCk14FhgS9ptYoD4isLUysR83gYgljIbEKYw5qNp5IrPP/slDUmAhIWGh4iJiouMjYghADs="


/*****************
 ** WEBPACK FOOTER
 ** ./~/url-loader!./bower_components/prettyphoto/images/prettyPhoto/facebook/default_thumbnail.gif
 ** module id = 105
 ** module chunks = 0
 **/